import { render, staticRenderFns } from "./UplataModal.vue?vue&type=template&id=017aa004"
import script from "./UplataModal.vue?vue&type=script&lang=js"
export * from "./UplataModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports